module.exports = "<div  id=\"close\"\n      (touchstart)=\"startDrag($event)\"\n      (touchmove)=\"updateDrag($event)\"\n      (touchend)=\"stopDrag()\">\n  <div id=\"close-top-line\"></div>\n  <div id=\"close-bottom-line\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/slideBar/slideBar.component.html
// module id = 435
// module chunks = 1